import type React from 'react';

/**
 * Ревизия пачки 8, пункт 1 (данные лида): нажатие навигационной кнопки НЕ
 * должно отбирать фокус у поля ввода.
 *
 * Порядок событий в браузере: `mousedown` → перевод фокуса (поле теряет фокус,
 * всплывает `focusout`) → `mouseup` → `click`. А `focusout` поля — это ровно
 * сигнал «ввод завершён» из WEB-1643: счётчик завершений растёт, эффект
 * авто-перехода срабатывает САМ, экран сменяется и кнопка размонтируется ещё
 * до `click`. Клик приземляется уже на НОВОМ экране: на телефоне палец
 * опускается в ту же точку, где теперь лежит другой элемент — отсюда «переход
 * через экран» и сквозной тап в вариант ответа (случайный ответ в лиде).
 *
 * `preventDefault` на `mousedown` отменяет ровно перевод фокуса и ничего
 * больше: `click` приходит как обычно, клавиатурный путь (Tab + Enter/Space)
 * не затронут вовсе — он фокус мышью не двигает. Поле остаётся в фокусе,
 * сигнала завершения ввода нет, переход происходит РОВНО по `onClick`.
 *
 * Вешается на ВСЕ навигационные кнопки рядом с полями (запасная «Далее»,
 * блочная «Кнопка Далее» в PublicBlockRenderer, «Назад»): гонка одна и та же,
 * а точечная защита одной кнопки оставила бы её на остальных.
 *
 * WEB-3402: вынесено из QuizScreenWizard.tsx без изменений — им пользуются
 * шапка плеера и запасная кнопка (QuizFallbackCta.tsx).
 */
export const keepFieldFocusOnPress = (e: React.MouseEvent): void => {
  e.preventDefault();
};
